import { useState, useCallback } from 'react';
import { get, post } from '../../utils/networkUtils';

export const useInboxMessages = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get all inbox messages
  const fetchInboxMessages = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await get('/admin/inbox-messages');
      return response.messages || [];
    } catch (err) {
      setError(err.message || 'Failed to fetch inbox messages');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Create new inbox message
  const createInboxMessage = useCallback(async (messageData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await post('/admin/inbox-messages', messageData);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to create inbox message');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchInboxMessages,
    createInboxMessage,
  };
};
